module.exports = __webpack_public_path__ + "static/floralminkblanket-2ab7e6318a92d7921666fc55c7381e78.png";